import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Table,
  Input,
  Card,
  UncontrolledTooltip
} from "reactstrap";
import {
  getUsersAdminRolesList,
  getRolesAdminByUser,
  getPermissionsAdminByUser,
  patchUsersAdminPermissions,
  putUserAdminUpdate,
  patchUsersAdminRoles,
  getUsersAdminPermissionsList,
  getUsersAdminPermissionsRoleList
} from "../../../helpers/api_rombo_helper";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { map } from "lodash";
import Spinners from "../../../components/Common/Spinner";
import { useNavigate } from "react-router-dom";
import PaginationV2 from "../../../components/Pagination/PaginationV2";

const Step2 = ({ step, setStep, name, phone, email, token, lastName, secondLastName, company, isRole, id, infoUser, setErrorAlert, setErrorAlertMessage }) => {

  const dispatch = useDispatch()
  const history = useNavigate();
  const [newRoles, setNewRoles] = useState([])
  const [listRoles, setListRoles] = useState([])
  const [idRoles, setIdRoles] = useState([])
  const [roles, setRoles] = useState([])
  const [permissions, setPermissions] = useState([]);
  const [newPermissions, setNewPermissions] = useState([]);
  const [selectedRol, setSelectedRol] = useState({})
  const [fListPermissions, setFListPermissions] = useState({});
  const [opts, setOpts] = useState({});
  const [isLoading, setLoading] = useState(true)
  const [selectedRoles, setSelectedRoles] = useState([])
  const [fPermissions, setFPermissions] = useState([]);
  const [filterDescription, setFilterDescription] = useState(null);
  const [filterRolName, setFilterRolName] = useState(null);
  const [buttonSearch1, setButtonSearch1] = useState(true)
  const [buttonSearch2, setButtonSearch2] = useState(true)
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = fPermissions.slice(indexOfFirstRecord, indexOfLastRecord);
  const nPages = Math.ceil(fPermissions.length / recordsPerPage)
  const [listPermissions, setListPermissions] = useState({
    page: 1,
    size: 10,
    total: 0,
    items: []
  });

  useEffect(() => {
    onGetUsersAdminRolesList()
    onGetUsersAdminPermissionsList()
    onGetRolesAdminByUser()
    onGetPermissionsAdminByUser()
  }, [dispatch, id]);

  useEffect(() => {
    hiddenRoles()
  }, [roles]);

  const onGetUsersAdminRolesList = () => {
    let arr = []
    let arrSelected = newPermissions
    getUsersAdminRolesList(token)
      .then((response) => {
        map(response, (item, key) => {
          roles.filter( (ele) => item.id == ele.value ).shift() ? null : arr.push({ value: item.id, label: item.description })
        })
        setListRoles([...arr])
      })
      .catch((error) => {
        console.error("Error - getUsersAdminRolesList - ", error)
      })
  }

  const hiddenRoles = () => {
    var myArray = listRoles.filter(ar => !roles.find(rm => (rm.value === ar.value && ar.label === rm.label) ))
    setListRoles([...myArray]);
  }

  const onGetUsersAdminPermissionsList = (newOpts = { page: 1, size: 10 }) => {
    setLoading(true);
    getUsersAdminPermissionsList(token, newOpts)
      .then((response) => {
        setListPermissions({
          page: response.page,
          size: response.size,
          total: response.total,
          items: response.items
        });
        setFListPermissions(response.items);
        setOpts(newOpts);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - getUsersAdminPermissionsList - ", error);
        setLoading(false);
      });
  };
  
  const onGetRolesAdminByUser = (newOpts = { page: 1, size: 100 }) => {
    let arr = []
    let arr2 = []
    getRolesAdminByUser(token, id, newOpts)
      .then((response) => {
        response.map((ele) => {
          arr2.push(ele.id)
          arr.push({ value: ele.id, label: ele.description })
        })
        setRoles(arr)
        setIdRoles([...arr2])
      })
      .catch((error) => {
        console.error("Error - getRolesAdminByUser - ", error)
      })
  }
  
  const onGetPermissionsAdminByUser = (newOpts = { page: 1, size: 100 }) => {
    let arr = []
    setFPermissions([])
    getPermissionsAdminByUser(token, id, newOpts)
      .then((response) => {
        setFPermissions([...response.items])
        let onFPermissions = response.items
        newPermissions.map((item) => onFPermissions.push(item))
        setFPermissions([...onFPermissions])
      })
      .catch((error) => {
        console.error("Error - getPermissionsAdminByUser - ", error)
      })
  }

  const onClickRemovePermission = (e) => {
    let arr = fPermissions
    let findPermission = fPermissions.filter(function(opt) {
      return opt.name === e.name
    }).shift();
    if(findPermission){
      patchUsersAdminPermissions(token, id, { permissions: [e.name] }, { params: { type: "REMOVE" } })
        .then((r_permissions) => {
          arr.splice(arr.indexOf(findPermission), 1)
          setFPermissions([...arr])
        })
        .catch((error) => {
          console.error("Error - patchUsersAdminPermissions ", error)
          setErrorAlertMessage((error.response?.data?.detail || error.message))
          if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
          setErrorAlert(true)
        })
    }
  }

  const onClickAddPermission = (e) => {
    let arr = fPermissions;
    let arr2 = newPermissions;
  
    arr.push(e);
    arr2.push({ ...e, individual: true });
  
    setFPermissions([...arr]);
    setNewPermissions([...arr2]);
  };
  
  const onBackNextStep = () => {
    setStep(step - 1);
  };  

  const onGetUsersAdminPermissionsRoleList = (id, newOpts = { page: 1, size: 10 }) => {
    let arr = []
    setPermissions(arr);
    getUsersAdminPermissionsRoleList(token, id, newOpts)
      .then((response) => {
        let arr = fPermissions;
        let arr2 = newPermissions;
        response.items.map((item) => {
          if(!fPermissions.filter((itemP) => itemP.name == item.name).shift()){ 
            arr.push({ ...item, rol_id: selectedRol.value, rol_name: selectedRol.label})
            arr2.push({ ...item, rol_id: selectedRol.value, rol_name: selectedRol.label})
          }
        })
        setPermissions(response)
        setNewPermissions([...arr2])
        setFPermissions(arr)
      })
      .catch((error) => {
        console.error("Error - getUsersAdminPermissionsRoleList - ", error)
      })
  }

  const onClickAddRol = () => {
    if(!selectedRol.value) return;

    let onRoles = roles
    let onIdRoles = idRoles
    onIdRoles.push(selectedRol.value)
    setIdRoles([...onIdRoles])
    onRoles.push(selectedRol)
    let onNewRoles = newRoles
    onNewRoles.push(selectedRol)
    setRoles([...onRoles]);
    setNewRoles([...onNewRoles]);
    onGetUsersAdminPermissionsRoleList(selectedRol.value, { size: 50, page: 1 });
    setSelectedRol({})
    onGetUsersAdminRolesList()
  }

  const onClickFilterList = (type = null) => {
    let arr = []
    buttonSearch1 ? (setFilterDescription("")) : null
    buttonSearch2 ? (setFilterRolName("")) : null
    buttonSearch1 ? document.getElementById(`${type == 'init' ? "filter1Name" : "filter2Name"}`).value = null : null
    buttonSearch2 ? document.getElementById(`${type == 'init' ? "filter1Rol" : "filter2Rol"}`).value = null : null
    fPermissions.map((item) => (item.description == filterDescription || item.rol_name == filterRolName) && arr.push(item) )
    type == "init" ? setButtonSearch1(!buttonSearch1) : setButtonSearch2(!buttonSearch2)
    type == "init" ?
      onGetUsersAdminPermissionsList({ page: 1, size: 10, description: filterDescription, rol_name: filterRolName }) :
        (arr.length == 0 ? setRolPermissions() : setFPermissions([...arr]))
  }

  const setRolPermissions = async () => {
    onGetPermissionsAdminByUser()
  }

  const onClickSave = async () => {
    let onPermissions = []
    newPermissions.map((item) => item.individual && onPermissions.push(item.name))
    let body  = {
      full_name: name,
      email: email,
      phone: phone,
      partner_name: company.label,
      is_staff: isRole == "STAFF",
      is_customer_admin: isRole == "ADMIN",
      is_customer_user: isRole == "USER"
    }
    if (infoUser.is_staff) {
      body.partner_id = company.value != null ? String(company.value) : null;
    }    
    if(roles.length != 0){
      putUserAdminUpdate(token, id, body)
        .then((response) => {
          localStorage.setItem("notify", "true")
          localStorage.setItem("headerText", i18n.t("UpdatedUser"))
          localStorage.setItem("bodyText", i18n.t("SuccessUpdatedUser"))
          if(onPermissions.length != 0){
            patchUsersAdminPermissions(token, id, { permissions: onPermissions }, { params: { type: "ADD" } })
              .then((r_permissions) => { console.log("Response - patchUsersAdminPermissions ", r_permissions) })
              .catch((error) => { console.error("Error - patchUsersAdminPermissions ", error) })
          }
          if(newRoles.length != 0){
            patchUsersAdminRoles(token, id, { ids: newRoles.map((item) => item.value ) }, { params: { type: "ADD" } })
              .then((r_roles) => console.log("Response - patchUsersAdminRoles ", r_roles))
              .catch((error) => console.error("Error - patchUsersAdminRoles ", error))
          }
          history("/users")
        })
        .catch((error) => {
          console.error("Error - putUserAdminUpdate ", error)
          setErrorAlertMessage((JSON.stringify(error.response?.data?.detail) || error.message))
          if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
          setErrorAlert(true)
        })
    }
  }

  const removeRole = (rol) => {
    let arr = roles
    let arr2 = newRoles
    let arr3 = listRoles
    let oldFPermissions = fPermissions
    let oldNewPermissions = newPermissions
    let findRole = roles.filter(function(opt) {
      return opt.value === rol.value
    }).shift();
    oldNewPermissions.map((per) => {
      if(rol.value === per.rol_id){
        oldNewPermissions.splice(oldNewPermissions.indexOf(per), 1)
      }
    })
    oldFPermissions.map((per) => {
      if(rol.value === per.rol_id){
        oldFPermissions.splice(oldFPermissions.indexOf(per), 1)
      }
    })
    setNewPermissions([...oldNewPermissions])
    setFPermissions([...oldFPermissions])
    var isNewRole = newRoles.filter((ele) => ele.value == rol.value).shift()
    arr.splice(arr.indexOf(findRole), 1)
    setRoles([...arr])
    arr2.splice(arr2.indexOf(findRole), 1)
    setNewRoles([...arr2]);
    arr3.push(findRole)
    setListRoles([...arr3])
    if(findRole && !isNewRole){
      patchUsersAdminRoles(token, id, { ids: [findRole.id || findRole.value] }, { params: { type: "REMOVE" } })
        .then((r_roles) => {
          onGetPermissionsAdminByUser()
        })
        .catch((error) => {
          console.error("Error - patchUsersAdminRoles ", error)
          setErrorAlertMessage((JSON.stringify(error.response?.data?.detail) || error.message))
          if(error.code == 500) setErrorAlertMessage(i18n.t("ServerError"))
          setErrorAlert(true)
        })
    }
  }

  return (
    <Fragment>
      <CardBody>
        <h6 className="employees-form-title" htmlFor="companyNameInput">
          {i18n.t("RolUser", { name, lastName })}
        </h6>
        <p className="employees-form-text">{i18n.t("DescUserRol")}</p>
        <Col xs={12} xxl={6} xl={6} className="pt-2">
          <Col xs={11} xxl={12} xl={12} className="pt-2 row">
            <Col xs={10} xxl={10} xl={10} className="">
              <Card>
                <Select
                  name="rol"
                  value={selectedRol}
                  id="roles"
                  placeholder={i18n.t("SelectRole")}
                  options={listRoles}
                  className="select2-selection"
                  onChange={(e) => {setSelectedRol(e)}}
                />
              </Card>
            </Col>
            <Col xs={2} xxl={2} xl={2} className="">
              <button
                className="btn btn-users"
                disabled={selectedRol.value == null}
                onClick={() => onClickAddRol()}>
                  {i18n.t("Add")}
              </button>
            </Col>
          </Col>
            {
              map(roles, (rol, key) => (
                <Col xs={12} xxl={5} xl={4} className="rounded-5 text-white p-1 bg-users mb-1">
                  <i onClick={() => removeRole(rol)} className="bx bx-x-circle mx-1"></i>
                  {rol.description || rol.label}
                </Col>
              ))
            }
          </Col>
        <Row>
          <Col xxl={6} md={6} xs={12}>
            <div className="table-responsive pt-3">
              <Col xxl={12} md={12} xs={12} className="pt-2 pb-2 bg-light d-flex text-center">
                <Col xxl={5} md={5} xs={1} className=""></Col>
                <Col xxl={7} md={7} xs={10} className="row">
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter1Name"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Name")}
                      disabled={!buttonSearch1}
                      onChange={(e) => setFilterDescription(e.target.value)}
                    />
                  </Col>
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter1Rol"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Category")}
                      disabled={!buttonSearch1}
                      onChange={(e) => setFilterRolName(e.target.value)}
                    />
                  </Col>
                  <Col xxl={2} md={2} xs={2} className="m-0 p-0">
                    <button
                      className="btn btn-users fs-10"
                      onClick={() => onClickFilterList("init")}>
                        {i18n.t(`${buttonSearch1 ? 'Search' : 'Clean'}`)}
                    </button>
                  </Col>
                </Col>
              </Col>
              <Table className="table table-responsive border">
                <thead>
                  <tr>
                    <th className="bg-light">{i18n.t("Name")}</th>
                    <th className="bg-light">{i18n.t("Category")}</th>
                    <th className="bg-light">{i18n.t("Actions")}</th>
                  </tr>
                </thead>
                {
                  isLoading ? null :
                    <tbody>
                      {map(fListPermissions, (permission, key) => (
                        <tr key={key}>
                          <td>{permission.description}</td>
                          <td>{permission.rol_name}</td>
                          <td>
                          <div className="d-flex gap-3">
                            {fPermissions.filter((item) => item.name == permission.name).shift() ? (
                              null
                            ) : (
                              <button
                                className="btn btn-users fs-8"
                                onClick={() => onClickAddPermission(permission)}>
                                  {i18n.t("Add")}
                              </button>
                            )}
                          </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                }
              </Table>
              {isLoading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <PaginationV2
                  currentPage={listPermissions.page}
                  pageSize={listPermissions.size}
                  totalItems={listPermissions.total}
                  onChangePage={(newPage) => {
                    onGetUsersAdminPermissionsList({ 
                      ...opts, 
                      page: newPage 
                    });
                  }}
                  isLoading={isLoading}
                />
              )}
            </div>
          </Col>
          <Col xxl={6} md={6} xs={12}>
            <div className="table-responsive pt-3">
              <Col xxl={12} md={12} xs={12} className="pt-2 pb-2 bg-light d-flex text-center">
                <Col xxl={5} md={5} xs={1} className=""></Col>
                <Col xxl={7} md={7} xs={10} className="row">
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter2Name"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Name")}
                      disabled={!buttonSearch2}
                      onChange={(e) => setFilterDescription(e.target.value)}
                    />
                  </Col>
                  <Col xxl={5} md={5} xs={5} className="">
                    <Input
                      id="filter2Rol"
                      className="form-control search-box me-2 mb-2 d-inline-block fs-10"
                      placeholder={i18n.t("Category")}
                      disabled={!buttonSearch2}
                      onChange={(e) => setFilterRolName(e.target.value)}
                    />
                  </Col>
                  <Col xxl={2} md={2} xs={2} className="m-0 p-0">
                    <button className="btn btn-users fs-10" onClick={() => onClickFilterList()}>
                      {i18n.t(`${buttonSearch2 ? 'Search' : 'Clean'}`)}
                    </button>
                  </Col>
                </Col>
              </Col>
              <Table className="table table-responsive border">
                <thead>
                  <tr>
                    <th className="bg-light">{i18n.t("Name")}</th>
                    <th className="bg-light">{i18n.t("Category")}</th>
                    <th className="bg-light">{i18n.t("Actions")}</th>
                  </tr>
                </thead>
                {
                  isLoading ? null :
                    <tbody>
                      {map(currentRecords, (permission, key) => (
                        <tr key={key}>
                          <td>{permission.description}</td>
                          <td>{permission.rol_name}</td>
                          <td>
                            {!idRoles.includes(permission.rol_id) && (
                              <div className="d-flex gap-3">
                                <div className="d-flex gap-3">
                                  <a
                                    className="text-danger"
                                    onClick={() => onClickRemovePermission(permission)}
                                  >
                                    <i className="mdi mdi-delete font-size-18" id="addtooltip" />
                                    <UncontrolledTooltip placement="top" target="addtooltip">
                                      {i18n.t("Eliminated")}
                                    </UncontrolledTooltip>
                                  </a>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                }
              </Table>
              {isLoading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <PaginationV2
                  currentPage={currentPage}
                  pageSize={recordsPerPage}
                  totalItems={fPermissions.length}
                  onChangePage={setCurrentPage}
                  isLoading={isLoading}
                />
              )}
            </div>
          </Col>
          <Col xxl={2} md={2} xs={12} className="d-flex pt-3">
            <button onClick={() => onClickSave()} className="btn btn-request">
              {i18n.t("SaveChange")}
            </button>
            <button onClick={() => onBackNextStep()} className="btn btn-go-back button-margin-minleft border fs-11">
              {i18n.t("Back")}
            </button>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step2;
